import $ from '../jQuery/jQuery';
import moduleRegistry from '../module-registry/module-registry';

const config = {
    selectors: {
        module: '.rfct-indication-selection',
        form: '.rfct-indication-selection__form',
        tbody: '.rfct-indication-selection__table tbody',
        tableRow: '.rfct-indication-selection__table-tr',
        submitButton: '.rfct-indication-selection__submit-btn',
        submitButtonLabel: '.rfct-indication-selection__submit-btn .rfct-button__label',
        quantityInput: '.rfct-input-plus-minus',
        removeButton: '.rfct-indication-selection__action .rfct-button--link--remove',
        resetButton: '.rfct-indication-selection__action .rfct-button--link--reset',
    },
    classNames: {
        tableRowInactive: 'rfct-indication-selection__table-tr--inactive',
    },
};

export default class IndicationSelection {
    constructor($rootElement, conf) {
        this._$rootElement = $rootElement;
        this._config = conf;
        this._elements = this._getDomElements();
    }

    _getDomElements() {
        return {
            $select: this._$rootElement.find(config.selectors.module),
            $form: this._$rootElement.find(config.selectors.form),
            $tbody: this._$rootElement.find(config.selectors.tbody),
            $tableRows: this._$rootElement.find(config.selectors.tableRow),
            $quantityInputs: this._$rootElement.find(config.selectors.quantityInput),
            $submitButton: this._$rootElement.find(config.selectors.submitButton),
            $submitButtonLabel: this._$rootElement.find(config.selectors.submitButtonLabel),
        };
    }

    init() {
        this._addEventListeners();
        this._updateSubmitButton();
    }

    _addEventListeners() {
        this._elements.$form.on('submit', (e) => {
            e.preventDefault();

            const productSelection = this._getProductSelection();
            $(document).trigger('rfct:submitindicationselection', productSelection);
        });

        this._elements.$quantityInputs.on('rfct:plusminuschange', (e, value) => {
            const $target = $(e.target);
            const $tableRow = IndicationSelection._getClosestTableRow($target);
            IndicationSelection._updateTableRowState($tableRow, value > 0);
            this._updateSubmitButton();
        });

        this._elements.$tableRows.each((i, tableRow) => {
            const $tableRow = $(tableRow);
            const $removeButton = $tableRow.find(config.selectors.removeButton);
            const $resetButton = $tableRow.find(config.selectors.resetButton);

            const inputPlusMinusInstance = IndicationSelection
                ._getInputPlusMinusInstanceByTableRow($tableRow);

            // set initial table row state
            IndicationSelection
                ._updateTableRowState($tableRow, inputPlusMinusInstance && inputPlusMinusInstance.getValue() > 0);

            $removeButton.on('click', () => {
                inputPlusMinusInstance.setValue(0);
            });

            $resetButton.on('click', () => {
                inputPlusMinusInstance.resetValue();
            });
        });
    }

    static _getClosestTableRow($child) {
        return $child.closest(config.selectors.tableRow);
    }

    static _getInputPlusMinusInstanceByTableRow($tableRow) {
        const $inputPlusMinus = $tableRow.find(config.selectors.quantityInput);

        return $inputPlusMinus[0].instance;
    }

    static _updateTableRowState($tableRow, active) {
        if (active) {
            $tableRow.removeClass(config.classNames.tableRowInactive);
        } else {
            $tableRow.addClass(config.classNames.tableRowInactive);
        }
    }

    _updateSubmitButton() {
        
        const productQuantity = this._getTotalProductQuantity();
        const buttonLabel = this._getSubmitButtonLabelByProductQuantity(productQuantity);
        this._elements.$submitButtonLabel.text(buttonLabel);

        if (productQuantity === 0) {
            this._elements.$submitButton.prop('disabled', true);
        } else {
            this._elements.$submitButton.prop('disabled', false);
        }
    }

    _getSubmitButtonLabelByProductQuantity(productQuantity) {
        let buttonLabel;

        switch (productQuantity) {
            case 0:
                buttonLabel = this._elements.$submitButton.attr('data-label-no-products');
                break;
            case 1:
                buttonLabel = this._elements.$submitButton.attr('data-label-add-product');
                break;
            default:
                buttonLabel = this._elements.$submitButton.attr('data-label-add-products');
                break;
        }

        buttonLabel = buttonLabel.replace(/{\s?productCount\s?}/g, productQuantity);
        return buttonLabel;
    }

    _getTotalProductQuantity() {
        let counter = 0;

        this._elements.$quantityInputs.each((i, quantityInput) => {
            const value = quantityInput.instance ? quantityInput.instance.getValue() : 0;

            counter += value;
        });

        return counter;
    }

    _getProductSelection() {
        const productSelection = {
            products: [],
            totalQuantity: 0,
        };

        this._elements.$tableRows.each((i, tableRow) => {
            const $tableRow = $(tableRow);
            const inputPlusMinusInstance = IndicationSelection
                ._getInputPlusMinusInstanceByTableRow($tableRow);
            const quantity = inputPlusMinusInstance.getValue();

            if (quantity <= 0) {
                // dont add products where quantity is less or equal to zero
                return;
            }

            const productIdentifier = $tableRow.attr('data-product-identifier');
            const productArticleName = $tableRow.attr('data-product-article-name');
            const productName = $tableRow.attr('data-product-name');
            const tipForBasket = $tableRow.attr('data-tip-for-basket');
            const image = $tableRow.attr('data-product-image');
            const href = $tableRow.attr('data-product-href');

            productSelection.products.push({
                identifier: productIdentifier,
                articleName: productArticleName,
                name: productName,
                quantity,
                imageSrc: image,
                href: href,
                tipForBasket,
                
            });

            productSelection.totalQuantity += quantity;
        });

        return productSelection;
    }
}

moduleRegistry.registerModule('IndicationSelection', IndicationSelection);
moduleRegistry.autoApplyModule('IndicationSelection', config.selectors.module);
